export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_2.6f3e37a5.jpg";